export const Wrap = {}

export default Wrap
